<div class="p-2">

  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Payments</div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <!-- Filters -->
      <div class="row bg-white pt-2 pb-2">
        <div class="col-12">
          <app-report-filters page="national-coupon-payments" [showCalendar]="true" [showCouponSourceRetailer]="false" (filterChange)="onfilterChange($event)"></app-report-filters>
        </div>
      </div>

      <!-- Payment Info -->
      <div class="row bg-white mt-2 pt-2 pb-2">
        <div class="col-12 text-center text-danger mt-4 mb-4">
          <i-bs class="text-black-50 mt-4 pt-4" name="creditCard" width="30" height="30"></i-bs>
          <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
        </div>
      </div>

    </div>
  </div>

</div>
